import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations, supportedLanguages } from "@/i18n/translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "caireen.lang";

function detectInitialLang() {
    if (typeof window === "undefined") return "de";
    const stored = window.localStorage?.getItem(STORAGE_KEY);
    if (stored && supportedLanguages.includes(stored)) return stored;
    const browser = (navigator.language || "de").slice(0, 2).toLowerCase();
    if (supportedLanguages.includes(browser)) return browser;
    return "de";
}

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(detectInitialLang);

    useEffect(() => {
        try {
            window.localStorage?.setItem(STORAGE_KEY, lang);
            document.documentElement.setAttribute("lang", lang);
        } catch (e) {
            // ignore
        }
    }, [lang]);

    const setLang = useCallback((next) => {
        if (supportedLanguages.includes(next)) setLangState(next);
    }, []);

    const t = translations[lang] || translations.de;

    return (
        <LanguageContext.Provider value={{ lang, setLang, t, supportedLanguages, translations }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLang = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLang must be used within LanguageProvider");
    return ctx;
};
